import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "panel-section p-bottom-8 request-expiration-date" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "has-text-weight-semibold" }, "Expiration", -1)
const _hoisted_3 = { class: "m-left-8" }
const _hoisted_4 = { class: "exemption-container" }
const _hoisted_5 = { class: "exemption-container" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "help" }, " If you exempt this request from deletion, it will not be automatically deleted from the portal even after the normal retention period passes. Including documents will exempt all documents on this request from deletion. If a request's expiration date is already in the past, the request will be deleted in the next retention cycle if exempt status is removed. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NrIconButton = _resolveComponent("NrIconButton")!
  const _component_NrTooltip = _resolveComponent("NrTooltip")!
  const _component_NrFormInput = _resolveComponent("NrFormInput")!
  const _component_NrIcon = _resolveComponent("NrIcon")!
  const _component_NrModal = _resolveComponent("NrModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["panel-item is-flex is-align-items-center is-justify-content-space-between", { 'panel-item--editable': _ctx.$can('read', 'admin_only_items') }])
    }, [
      _hoisted_2,
      (_ctx.$can('read', 'admin_only_items'))
        ? (_openBlock(), _createBlock(_component_NrTooltip, {
            key: 0,
            label: "Edit request retention exemption"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_NrIconButton, {
                variant: "minimal-neutral",
                icon: { name: 'pencil-alt', type: 'regular' },
                "aria-label": "Edit request retention exemption",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleModal(true)))
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", null, _toDisplayString(_ctx.expiration), 1)
    ]),
    _createVNode(_component_NrModal, {
      title: "Change request retention status",
      show: _ctx.showModal,
      hasSecondaryButton: true,
      disabeButtons: _ctx.updating,
      secondaryButtonText: "Cancel",
      primaryButtonText: "Change retention status",
      onOnCloseClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleModal(false))),
      onOnSecondaryClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggleModal(false))),
      onOnPrimaryClick: _ctx.handleSaveExempt
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent","stop"]))
        }, [
          _createVNode(_component_NrTooltip, {
            label: "If you exempt this request from deletion, it will not be automatically deleted from the portal even after the normal retention period passes.",
            position: "right"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_NrFormInput, {
                  class: "exemption-checkbox",
                  type: "checkbox",
                  label: "Exempt request from deletion",
                  name: "exempt",
                  modelValue: _ctx.newExempt,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newExempt) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_NrIcon, { name: "info-circle" })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_NrTooltip, {
            label: "If you exempt documents from deletion, they will not be automatically deleted from the portal even after the normal retention period passes. If the request is deleted and documents are exempt they can be still accessed from the documents page.",
            position: "right"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_NrFormInput, {
                  class: "exemption-checkbox",
                  type: "checkbox",
                  label: "Exempt all documents on this request from deletion",
                  name: "exemptedDocuments",
                  modelValue: _ctx.exemptedDocuments,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.exemptedDocuments) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_NrIcon, { name: "info-circle" })
              ])
            ]),
            _: 1
          }),
          _hoisted_6
        ], 32)
      ]),
      _: 1
    }, 8, ["show", "disabeButtons", "onOnPrimaryClick"])
  ]))
}